//CarbonModal.vue


<template>
<div class="overlay">

	<div class="overlay">

		<div class="modal">

			<h1>Carbon</h1>

			<div class="modal-content">

				The calculated embodied carbon result correspods to a 'cradle-to-gate' consideration. <br>
				This includes the LCA modules A1-A3 without sequestration (carbon storage).<br>
				Thus, the modules C3 and C4 are also included for structural members made of timber.<br>

				To rate the different results, the SCORS rating scheme proposed by the IStructE is implemented in the Comparison-Dashboard. <br>
				Keep in mind that this rating was developed using the ICE database for embodied carbon factors.
				<br>
				<br>

				Further information on the ECFs (ICE database):<br>
				<a id="link" href="https://www.istructe.org/IStructE/media/Public/Resources/istructe-how-to-calculate-embodied-carbon.pdf">
					See the IStructE's 'How to calculate embodied carbon' Guide
				</a>

				<br>
				<br>

				Further information on the SCORS rating scheme:<br>
				<a id="link" href="https://www.istructe.org/IStructE/media/Public/TSE-Archive/2020/Setting-carbon-targets-an-introduction-to-the-proposed-SCORS-rating-scheme.pdf">
					See the IStructE SCORS rating
				</a>




			</div>

			<button id="button-close-modal" @click="$emit('closeModalClicked', 'carbonModal')">
				Close
				<i id="arrow-right" class="fas fa-chevron-right"></i>
			</button>

		</div>
	</div>
</div>
  
</template>

<script>


import * as StructuralMember from "../../classes/StructuralMember.js";

export default {
	emits: [
			'closeModalClicked',
	],
	props: {
		}
	,
	data() {
		return {
			memberResultsDeep: this.memberResults,
			crossSectionBeams: [],
			crossSectionColumns: []
		}; 
	},
	methods: {
	},
	mounted() {

	}
}

</script>

<style scoped>

.overlay {
	position: fixed; 
	top: 0%;
	left:0%;
	height: 100vh;
	width: 100vw;
	/* background: white; */
	background-color: transparent;
	backdrop-filter: blur(5px);
	z-index: 100;
}

.modal {
	position: fixed; 
	top: 20%;
	left:10%;
	height: 600px;
	width: 60vw;
	background: rgb(240, 240, 240);
	border-radius: 40px;
	padding: 10px 40px;
	overflow: hidden;
	box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3);
}

.modal h1{
	color: rgba(0, 0, 0, .70);
	font-family: Roboto;
	font-weight: 300;
	font-size: 30px;
}


.member-container {
	padding: 5px 30px;
	border-radius: 20px; 
	/* border: 1px solid rgba(0, 0, 0, 1); */
	background: rgba(255, 255, 255, 1);
	margin-bottom: 15px;
}

.member-container h2{
	color: rgba(0, 0, 0, .70);
	font-family: Roboto;
	font-weight: 300;
	font-size: 20px;
	text-decoration: underline;
}

#container-slabs{
	background: rgb(143, 188, 143, .4);
}

#container-columns{
	background: rgb(135, 206, 250, .4);
}

#container-beams{
	background: rgb(14, 82, 26, .4);
}


.modal-content {
	height: 74%;
	/* border: 1px solid black; */
	overflow-y: scroll;
	overflow-x: hidden;
	color: rgba(0, 0, 0, .70);
	font-family: Roboto;
	font-weight: 300;
	font-size: 12px;
}


#link {
	/* text-decoration: none; */
	color: rgba(0, 0, 0, .7);
	font-size: 14px;
	font-weight: 400;
}


#button-close-modal {
	/* border-radius: 25px;
	height: 34px;
	min-width: 80px;
	max-width: 120px;
	margin-top: 30px;
	background: transparent;
	border: solid 1px black;
	color:black;
	cursor: pointer;
	font-family: Roboto;
	font-weight: 300;
	box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3); */

	border: none;
	background: transparent;
	font-family: Roboto;
	font-weight: 400;
	font-size: 16px;
	color: rgba(66, 130, 235, 1);
	margin: 0;
	padding: 0;
	cursor: pointer;
}

.fas {
	margin-left: 10px;
	transform: scale(.8);
}

#button-close-modal:hover > .fas {
	transform: translateX(10px) scale(0.8);
	transition: .3s ease-in;
} 

#button-close-modal:active {
	background: rgba(235, 235, 235, 0.2);
	transform: translateY(1px);
}


/* width */
::-webkit-scrollbar {
  width: 8px;
  /* display: none; */
}

/* Track */
::-webkit-scrollbar-track {
	display: none;
	box-shadow: inset 0 0 5px grey; 
	border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, .1); 
	border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, .2); ; 
}



</style>